module.exports = "<div class=\"articlePageDividingLine\">\n    &nbsp;\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/articleDividingLine/articleDividingLine.component.html
// module id = ../../../../../src/app/components/articleDividingLine/articleDividingLine.component.html
// module chunks = main